import { TypeDefinition } from "../generic";

export class AbstractStatuses {
    public static Deleted: TypeDefinition = { id: -1, name: "Deleted" };
    public static Unsubmitted: TypeDefinition = { id: 0, name: "Not submitted" };
    public static Incomplete: TypeDefinition = { id: 1, name: "Incomplete" };
    public static Complete: TypeDefinition = { id: 2, name: "Complete" };
    public static Accepted: TypeDefinition = { id: 4, name: "Accepted" };
    public static Rejected: TypeDefinition = { id: 9, name: "Rejected" };

    public static Values: TypeDefinition[] = [
        AbstractStatuses.Unsubmitted,
        AbstractStatuses.Incomplete,
        AbstractStatuses.Deleted,
        AbstractStatuses.Complete,
        AbstractStatuses.Accepted,
        AbstractStatuses.Rejected,
    ];

    public static IDs: number[] = AbstractStatuses.Values.map((v) => v.id);

    public static SubmittedValues: TypeDefinition[] = [
        AbstractStatuses.Incomplete,
        AbstractStatuses.Complete,
        AbstractStatuses.Accepted,
    ];

    public static isSubmitted = (statusId: number | { statusId: number }) => {
        const s = typeof statusId === "number" ? statusId : statusId.statusId;
        return AbstractStatuses.SubmittedValues.map((v) => v.id).indexOf(s) > -1;
    }

    public static isUnsubmitted = (statusId: number | { statusId: number }) => {
        const s = typeof statusId === "number" ? statusId : statusId.statusId;
        return s === AbstractStatuses.Unsubmitted.id;
    }

    public static isRejected = (statusId: number | { statusId: number }) => {
        const s = typeof statusId === "number" ? statusId : statusId.statusId;
        return s === AbstractStatuses.Rejected.id;
    }
}



// WEBPACK FOOTER //
// ./src/models/abstract/AbstractStatus.ts